if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      get submitButton() {
        return this.querySelector('[type="submit"]');
      }
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        // this.bxgy = this.querySelector('bxgy-data');
        this.bxgyData = this.getBxgyData(this.querySelector('bxgy-data'));
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      getAddItemUrl(addedVariant) {
        var currentCart = this.getCurrentCartData();
        const discount_code = window.product_discount_code;
        //console.log(currentCart, 'currentCart', discount_code)

        var variant_queries = `${currentCart.variant}${addedVariant}:1`;
        if (currentCart.discount.split(',').filter(d => d == discount_code).length) {
          var discount_queries = `discount=${currentCart.discount}`;
        } else {
          discount_queries = `discount=${currentCart.discount}${discount_code},`;
        }

        var currentVariantQuantity = 1;
        if (currentCart.variant.includes(addedVariant)) {
          var existed = currentCart.variant.split(',').filter(v => v.includes(addedVariant))[0].split(':')[1];
          currentVariantQuantity += parseInt(existed);
        }

        // var bxgyData = this.getBxgyData();
        // //console.log(bxgyData);
        var attributes = '';

        for (const code in this.bxgyData) {
          if (this.bxgyData.hasOwnProperty(code)) {
            discount_queries += `${code},`
          }
          // var gift_attributes = `${addedVariant}:${this.bxgyData[code].customerBuysQuantity}`;
          // this.bxgyData[code].variants.forEach(v => {
          //   gift_attributes += `,${v}:1`;
          // })

          //console.log('add attributes', window.cart_attributes)
          attributes = window.cart_attributes ? window.cart_attributes : '';

          //!!!!! BE CAREFUL
          // if (currentVariantQuantity >= parseInt(this.bxgyData[code].customerBuysQuantity)) {
          //   this.bxgyData[code].variants.forEach(v => {
          //     if (!variant_queries.includes(v)) {
          //       variant_queries += `,${v}:1`;
          //       attributes += `&attributes[__${addedVariant}_${v}]=${addedVariant}:${this.bxgyData[code].customerBuysQuantity},${v}:1`;
          //     }
          //   })
          // }
        }
        return `/cart/${variant_queries}?${discount_queries}&storefront=true${attributes}`;
      }
      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        var addedVariant = formData.get("id");
        var queries = this.getAddItemUrl(addedVariant);
        //console.log(queries, 'queries')
        await fetch(queries).then((res) => {
          // publish(PUB_SUB_EVENTS.cartUpdate, {
          //   source: 'product-form',
          //   productVariantId: formData.get('id'),
          //   action: 'addToCart'
          // })
          // this.cart.renderContentFromCart();
        })
          .catch((e) => {
            console.error(e);
          })


        await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble&section-id=${this.dataset.sectionId}`)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            // if (!this.error)
            //   publish(PUB_SUB_EVENTS.cartUpdate, {
            //     source: 'product-form',
            //     productVariantId: formData.get('id'),
            //     cartData: response,
            //   });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContentFromCart(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              action: 'addToCart'
            })
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      getBxgyData(node) {
        var codes = {}
        if (!node) return codes;
        node.querySelectorAll('bxgy-item').forEach(item => {
          var variants = [];
          item.querySelectorAll('bxgy-product').forEach(item => {
            variants.push(item.getAttribute("data-variant-id"))
          })
          var el = {
            code: item.getAttribute("data-code"),
            customerBuysQuantity: item.getAttribute("data-customerbuys-quantity"),
            variants: variants
          }
          codes[item.getAttribute("data-code")] = el;
        })

        return codes;
      }

      getCurrentCartData() {
        var variant = [];
        var discount = '';
        const current = window.current_cart_data;
        for (var key in current) {
          if (current.hasOwnProperty(key)) {
            variant.push(`${current[key].variant_id}:${current[key].quantity}`);
            discount += current[key].discounts ? current[key].discounts : '';
          }
        }
        //console.log(discount, current, 'current')
        return {
          variant: variant.length ? variant.join(',') + ',' : '',
          discount: discount
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
